import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LcsResponsiveTableModule, LcsTableModule } from '@lcs/shared/table';
import { PagedTableWrapperModule } from '@ndt/report-output/shared/paged-table-wrapper/paged-table-wrapper.module';
import { CallParkingLotRegisterModule } from 'src/app/pages/call-parking-register/call-logs-register.module';
import { TilesModule } from '../../tiles.module';
import { SharedTileModule } from '../shared/shared-tile.module';
import { CallParkingTileComponent } from './call-parking-tile.component';

@NgModule({
   declarations: [CallParkingTileComponent],
   imports: [
      CommonModule,
      TilesModule,
      SharedTileModule,
      CallParkingLotRegisterModule,
      LcsResponsiveTableModule,
      ScrollingModule,
      RouterModule,
      PagedTableWrapperModule,
      LcsTableModule,
   ],
   exports: [CallParkingTileComponent],
})
export class CallParkingTileModule {}
